import template from './targets.html';

class TargetsComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    SchoolCommonRoomService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.SchoolCommonRoomService = SchoolCommonRoomService;
  }

  $onChanges(changes) {
    if (changes.schoolCommonRoom) {
      this.schoolCommonRoom = {...this.schoolCommonRoom};
    }

    if (changes.me) {
      this.me = {...this.me};
    }
  }

  update(form) {
    if (form.$invalid) {
      return false;
    }

    this.SchoolCommonRoomService.configuration(this.schoolCommonRoom).then(schoolCommonRoom => {
      this.schoolCommonRoom = schoolCommonRoom;
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Pomyślnie dodano cele i zadania świetlicy')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(({MessagePL}) => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent(MessagePL)
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }
}

export const Targets = {
  bindings: {
    schoolCommonRoom: '<',
    me: '<'
  },
  template,
  controller: TargetsComponent
};
